import axios from 'axios';
import configuration from "@/utils/configuration";
export const leaveService = {

// ------ FOR ADMIN ONLY ----
   getCoachLeaveByStatus(params) {
    return axios.get(`${configuration.backUrl}/coach-leave/by-status`, {
      withCredentials: true,
      params,
    });
  },
  getCoachRoleLeaveDetail(coachLeaveId) {
    return axios.get(`${configuration.backUrl}/coach-leave/detail`, {
      withCredentials: true,
      params: { coach_leave_id: coachLeaveId },
    });
  },
  getCoachLeaveDetail(coachLeaveId) {
    return axios.get(`${configuration.backUrl}/coach-leave/management/detail`, {
      withCredentials: true,
      params: { coach_leave_id: coachLeaveId },
    });
  },
  postLeaveRequest(payload) {
    return axios.post(`${configuration.backUrl}/coach-leave/management`, payload, {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true,
    });
  },
  getConflictCourseList(params) {
    return axios.get(`${configuration.backUrl}/coach-leave/management/affect-course`, {
      withCredentials: true,
      params,
    });
  },
  patchApproveLeaveReq(coachLeaveId) {
    return axios.patch(`${configuration.backUrl}/coach-leave/management/approve`, {}, {
      withCredentials: true,
      params: { coach_leave_id: coachLeaveId },
    });
  },
  patchSubClassDetail(coachLeaveCourseId,paylaod) {
    return axios.patch(`${configuration.backUrl}/coach-leave/management`,paylaod, {
      withCredentials: true,
      params: { coach_leave_course_id: coachLeaveCourseId },
    });
  },
  patchRejectLeaveReq(params) {
    return axios.patch(`${configuration.backUrl}/coach-leave/management/reject`, {}, {
      withCredentials: true,
      params,
    });
  },

// -------------------------- FOR COACH ONLY ----------------
getAvailableCoachList() {
    return axios.get(`${configuration.backUrl}/coach-leave/available-coach`, {
      withCredentials: true,
    });
  },
 getCoachLeaveList(params) {
    return axios.get(`${configuration.backUrl}/coach-leave/dashboard`, {
      withCredentials: true,
      params,
    });
  },
 getCoachEffectCourse(params) {
    return axios.get(`${configuration.backUrl}/coach-leave/affect/course`, {
      withCredentials: true,
      params,
    });
  },
createCoachLeaveReq(payload) {
    return axios.post(`${configuration.backUrl}/coach-leave/affect`,  payload , {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true,
    });
  },
editCoachLeaveReq(payload, coachLeaveId) {
    return axios.patch(`${configuration.backUrl}/coach-leave`, { data: payload }, {
      withCredentials: true,
      params: { coach_leave_id: coachLeaveId },
    });
  },
cancelCoachLeave(coachLeaveid) {
    return axios.patch(`${configuration.backUrl}/coach-leave/cancel`, {}, {
      withCredentials: true,
      params: { coach_leave_id: coachLeaveid },
    });
  },
};
